'use client';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import styles from './styles/featuredCourses.module.css';
import { generateSlug } from '@/lib/slugify';

export default function FeaturedCourses() {
  const [courses, setCourses] = useState([]);
  const router = useRouter();

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/api/classes/featured');
        if (!res.ok) throw new Error('Failed to fetch courses');
        const data = await res.json();
        setCourses(data.courses || []);
      } catch (e) {
        console.error('Error fetching courses:', e);
      }
    })();
  }, []);

  // 🔵 helper to limit description length
  const truncateText = (text, maxLength = 150) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  return (
    <section className={styles.featuredCourses}>
      {/* Circle-wrapped header */}
      <div className={styles.featuredHeaderCircle}>
        <h2>Featured Courses</h2>
        <p>Explore some of our most popular courses with both kids and parents!</p>
      </div>

      <div className={styles.courseContainer}>
        {courses.map((course) => (
          <div className={styles.courseCard} key={course.id}>
            <Image
              src={course.image}
              alt={course.name}
              width={300}
              height={200}
              quality={80}
              style={{ objectFit: 'cover' }}
              unoptimized
              loading="lazy"
              decoding="async"
            />

            <div className={styles.courseInfo}>
              <h3>{course.name}</h3>

              {/* Apply 200 character limit */}
              <p>{truncateText(course.description, 200)}</p>

              <button
                className={styles.moreBtn}
                onClick={() => router.push(`/classes/${generateSlug(course.name, course.id)}`)}
              >
                More
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}